export const SELECT_WEEKS = 'SELECT_WEEKS_WEEKS_LITTER';
export const SELECT_LITTER = 'SELECT_LITTER_WEEKS_LITTER';
export const SET_PREGNANCY = 'SET_PREGNANCY_WEEKS_LITTER';
export const SET_LACTATION = 'SET_LACTATION_WEEKS_LITTER';
export const SET_STERILISED = 'SET_STERILISED_WEEKS_LITTER';
export const DEFAULT = 'DEFAULT_WEEKS_LITTER';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_WEEKS_LITTER';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_WEEKS_LITTER';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_WEEKS_LITTER';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
